import { motion } from 'framer-motion';
import { useMeCore } from '../../../core/modules/me';
import { useEffect } from 'react';
import { useNavigationCore } from '../../../core/router/navigation';

function Welcome() {
  const { user, getMeUser } = useMeCore();
  const { goToMeCompanies } = useNavigationCore();

  useEffect(() => {
    getMeUser();
  }, [getMeUser]);

  useEffect(() => {
    if (user) {
      goToMeCompanies();
    }
  }, [goToMeCompanies, user]);

  return (
    <div className="flex flex-col flex-1 items-center justify-center p-16">
      <div className="w-full max-w-3xl text-center">
        <motion.div
          initial={{ opacity: 0, scale: 0.6 }}
          animate={{ opacity: 1, scale: 1, transition: { delay: 0.1 } }}
        >
          <div>LOADING</div>
        </motion.div>
      </div>
    </div>
  );
}

export default Welcome;
